import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HwtButton } from '../Buttons/HwtButton';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import { translate } from 'translations/translator';
import ModalsTranslationVariant from 'translations/variants/modals';
import { ModalPadding } from 'styles/style-constants';
const getTranslation = (key: ModalsTranslationVariant) => translate('modals', key);

const { removeAndCreate, cancel, removeLessonTitle, removeLessonDescription } =
  ModalsTranslationVariant;

type Props = {
  lessonName: string;
  handleOnRemove: () => void;
};

export const RemoveLessonModal = ({ lessonName, handleOnRemove }: Props) => {
  const [, { closeModal }] = useModal();
  const classes = useStyles();

  const withCloseModal = cb => () => {
    cb();
    closeModal();
  };

  return (
    <Box className={classes.container}>
      <Box>
        <Typography variant="h6">
          {`${getTranslation(removeLessonTitle)} "${lessonName}" lesson?`}
        </Typography>
      </Box>
      <Typography variant="body1">{getTranslation(removeLessonDescription)}</Typography>
      <Box className={classes.actionItem}>
        <HwtButton onClick={closeModal} variant="outlined">
          <Typography>{getTranslation(cancel)}</Typography>
        </HwtButton>
        <HwtButton
          onClick={withCloseModal(handleOnRemove)}
          variant="contained"
          color="secondary"
          className={classes.removeBtn}
        >
          <Typography>{getTranslation(removeAndCreate)}</Typography>
        </HwtButton>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
    textAlign: 'center',
    height: '301px',
    width: '616px',
    backgroundColor: '#fff',
    ...ModalPadding
  },
  actionItem: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  removeBtn: {
    width: '217px !important'
  }
}));
